import request from '@/utils/request'

/**
 * 获取映射列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listMappings(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.listMappings',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取映射域列表
 * @param {Object} params 查询参数，默认page=1, row=300
 * @returns {Promise} Promise对象
 */
export function listMappingDomains(params = { page: 1, row: 300 }) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.listMappingDomain',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存映射
 * @param {Object} data 映射数据
 * @returns {Promise} Promise对象
 */
export function saveMapping(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.saveMapping',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新映射
 * @param {Object} data 映射数据
 * @returns {Promise} Promise对象
 */
export function updateMapping(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.updateMapping',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除映射
 * @param {Object} data 映射数据
 * @returns {Promise} Promise对象
 */
export function deleteMapping(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.deleteMapping',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}